import { ExpandedHistoricalEntity, HistoricalConversation, HistoricalWorkItem, historicalWorkItemExpandableEntities } from "@buzzeasy/shared-frontend-utilities";

export type ExpandedHistoricalWorkItemDto = ExpandedHistoricalEntity<
  HistoricalWorkItem,
  "agent" | "channel" | "conversations" | "queue"
>;

export const expandedHistoricalWorkItemFields: (typeof historicalWorkItemExpandableEntities[number])[] = [
  "agent",
  "channel",
  "conversations",
  "queue",
];

type WorkItemOverrideProps = "startTimeUtc" | "endTimeUtc" | "conversations";
type ConversationOverrideProps = "startedAtUtc" | "endedAtUtc" | "customer";

export interface InternalHistoricalWorkItem extends Omit<HistoricalWorkItem, WorkItemOverrideProps> {
  startTimeUtc: Date;
  endTimeUtc: Date;
  conversations: InternalHistoricalConversation[];
}

export interface InternalHistoricalConversation extends Omit<HistoricalConversation, ConversationOverrideProps> {
  startedAtUtc: Date;
  endedAtUtc: Date;
  customerIdentifier?: string;
  customer?: {
    id: string;
    firstName: string;
    middleName: string;
    lastName: string;
    emailAddress: string | null;
    phoneNumber: string | null;
    identifiedEmailAddress: string | null;
  };
}

export interface HistoricalBusinessUnit {
  id: string;
  name: string;
}

export interface HistoricalWorkItemRelatedEntity {
  id: string;
  name: string;
}
